export type AchievementType = "html" | "pdf" | "图片" | "word" | "ppt";

export const achievementTypeLabel: Record<AchievementType, string> = {
  html: "HTML",
  pdf: "PDF",
  图片: "图片",
  word: "Word",
  ppt: "PPT",
};

export type AchievementRow = {
  id: string;
  title: string;
  desc: string;
  date: string;
  type: AchievementType;
  badge: string;
};

export const INITIAL_ACHIEVEMENTS: AchievementRow[] = [
  {
    id: "ac1",
    title: "量子纠错综合报告 V2.1",
    desc: "基于 5 篇核心文献的综合分析，含关键结论与可视化图表",
    date: "2026-04-15",
    type: "pdf",
    badge: "bg-red-50 text-red-600",
  },
  {
    id: "ac2",
    title: "分子动力学模拟结果图集",
    desc: "36 张高分辨率模拟截图与数据可视化图，含说明文字",
    date: "2026-04-12",
    type: "图片",
    badge: "bg-emerald-50 text-emerald-600",
  },
  {
    id: "ac3",
    title: "材料筛选技术说明（网页版）",
    desc: "高通量计算筛选 200+ 候选材料，含交互式图表与原始数据下载",
    date: "2026-04-08",
    type: "html",
    badge: "bg-blue-50 text-[#3D69E8]",
  },
  {
    id: "ac4",
    title: "实验记录与参数表（Word）",
    desc: "多轮实验条件、仪器读数与异常记录，便于组内复核与归档",
    date: "2026-04-06",
    type: "word",
    badge: "bg-slate-50 text-slate-700",
  },
  {
    id: "ac5",
    title: "季度组会汇报（PPT）",
    desc: "研究进展、里程碑与下阶段计划，含关键图表与结论页",
    date: "2026-04-03",
    type: "ppt",
    badge: "bg-orange-50 text-orange-700",
  },
];

